import React, { Component } from "react";
import * as Icon from "react-feather";
import clsx from "clsx";

import "./tools-collapsible-panel.css";

class ToolsCollapsiblePanel extends Component {
	constructor(props) {
		super(props);

		this.state = { isOpen: Boolean(props.defaultOpen) };
	}

	onToggle = () => {
		const willOpen = !this.state.isOpen;
		this.setState({ isOpen: willOpen });

		const { onOpen } = this.props;
		if (willOpen && onOpen) {
			onOpen();
		}
	};

	render() {
		const { title, status, hint } = this.props;
		const { isOpen } = this.state;

		const chevronClasses = clsx("tools-collapsible__chevron", isOpen && "tools-collapsible__chevron--open");

		return (
			<div className="tk-panel tools-collapsible">
				<button className="tools-collapsible__header" onClick={this.onToggle} type="button" aria-expanded={isOpen}>
					<span className={chevronClasses}>
						<Icon.ChevronRight size={16} />
					</span>
					<span className="tk-section-label tools-collapsible__title">{title}</span>
					{status}
					<span className="tools-collapsible__hint tk-text-muted">{isOpen ? "Click to collapse" : hint || "Click to expand"}</span>
				</button>

				{isOpen && <div className="tools-collapsible__body">{this.props.children}</div>}
			</div>
		);
	}
}

export default ToolsCollapsiblePanel;
